<template>
  <div class="room-content">
    <Navbar :appTitle="appTitle" @ClickRight="ClickRight"/>
    <Search 
      ref="topSearch" 
      class="search" 
      placeholder="出入库编号 | 物品名称" 
      :isAdd="false" 
      :isScreen="true" 
      :isType="true" 
      @onSearch="onSearch"
      @onScreen="onScreen" >
    </Search>
    <search-tag ref="SearchTag" @getCategory="getCategory"></search-tag>
    <!--分页列表 -->
    <div class="listBox">
      <pageList :usedGetMethods="false" ref="pageList" :checkedShow="false" :columns="columns" :minLen="4" :listUrl="listUrl" @toOtherPage="toOtherPage">
      </pageList>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/navBar/navBar_right";
import Search from "@/components/search";
import pageList from "@/components/pageList";
import SearchTag from "./SearchTag";

export default {
  name: "inOutDetails",
  components: {
    Navbar,
    Search,
    pageList,
    SearchTag
  },
  data() {
    return {
      appTitle: "出入库明细",
      listUrl: "/jksaas-produce/produce/warehouse/warehouseEntryDetail/warehouseDetailList", //列表接口
      columns: {
        titleKey: "serialName", //标题
        subtitleKey: 'serialSpecifications', //副标题
        content: [
          //内容
          {
            name: "出入库类型",
            key: ["warehouseTypeName"],
          },
          {
            name: "出入库时间",
            key: ["warehouseTime"],
          },
          {
            name: "出入库数量",
            key: ["inWarehouseNum"],
          },
          {
            name: "出入库编号",
            key: ["entryCode"],
            type: 'link'
          },
        ],
      },
      keyword: '',
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.SearchTag.showSearchTag) {
      this.appTitle = '出入库明细';
      this.$refs.SearchTag.showSearchTag = false;
      next(false);
    } else {
      next();
    }
  },
  mounted() {
    if(this.$route.query.serialNumber) { // 自实时库存页来
      let searchObj = this.$route.query
      this.searchQuery(searchObj);
    }else {
      this.searchQuery();
    }
  },
  methods: {
    // 搜索
    searchQuery(searchObj) {
      let params = {
        ...searchObj,
      };
      this.$refs.pageList.searchQuery(params);
    },
    // 查询
    onSearch(v) {
      this.keyword = v;
      let searchObj = {
        keyword: this.keyword,
      };

      if(this.$route.query.serialNumber) { // 自实时库存页来
        searchObj = {
          ...searchObj,
          ...this.$route.query
        }
      }

      this.searchQuery(searchObj);
    },
    // 更多查询页面 
    onScreen() {
      this.appTitle = "更多筛选";
      this.keyword = this.$refs.topSearch.value;

      let searchObj = {}
      if(this.$route.query.serialNumber) { // 自实时库存页来
        searchObj = this.$route.query
      }
      this.$refs.SearchTag.showModal(this.keyword, searchObj);
    },
    getCategory(sureObj) {
      this.appTitle = "出入库明细";
      this.keyword = sureObj.keyword;
      this.$refs.topSearch.value = sureObj.keyword;
      this.searchQuery(sureObj);
    },
    // 出入库明细
    handleDetail() {

    },
    // 出入库编号跳转 出库单/入库单  详情页
    toOtherPage(item) {
      if (item.inOutType == "0") {
        this.$router.push({
          path: "/inventoryOrderDetail",
          query: {
            id: item.inOutId,
          },
        });
      }else {
        this.$router.push({
          path: "/outboundOrderDetail",
          query: {
            id: item.inOutId,
          },
        });
      }
      
    },
    ClickRight() {
      this.$refs.SearchTag.showSearchTag = false;
      this.$router.push({
        path: "/application",
      });
    }
  },
};
</script>
<style lang="less" scoped>
.flex(@jc,@ai,@fd:row) {
  display: flex;
  justify-content: @jc;
  align-items: @ai;
  flex-direction: @fd;
}
.search {
  position: fixed;
  top: 93px;
  z-index: 98;
  width: 100%;
}
.listBox {
  margin-top: 120px;
  overflow-y: auto;
}
.room-content {
  height: 100vh;
  overflow-y: scroll;
  .serach {
    height: 0.33rem;
    background: #f2f2f6;
    border-radius: 0rem;
    margin-bottom: 0.16rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 0.33rem;
    padding: 0.1rem 0.12rem;
    .placeh {
      font-size: 0.16rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888888;
      line-height: 0.23rem;
    }
    .icon {
      width: 0.15rem;
      height: 0.16rem;
    }
  }
}
.operateBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  padding-right: 3px;
  font-size: 28px;
  font-weight: 500;
  color: #1890ff;
}
.pubBtn {
  margin-right: 20px;
  &:nth-last-child(1) {
    margin-right: 0;
  }
}
</style>